module.exports = "/build/web/svg/calendar-clock.9325c7ee0894391db5637e7254df3d1a.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/calendar-clock.svg
// module id = 149
// module chunks = 24